export default "__VITE_ASSET__mnJsMLA8__"